import React, { useState } from "react";

const data = [
  {
    screen_id: 1,
    screen_name: "Application Settings",
    sections: [
      { sec_id: 1, sec_name: "Personal Information" },
      { sec_id: 2, sec_name: "Addresses" },
      { sec_id: 3, sec_name: "Job Detail" },
      { sec_id: 4, sec_name: "Custom Fields" },
    ],
  },
  {
    screen_id: 2,
    screen_name: "Client Master",
    sections: [
      { sec_id: 1, sec_name: "Personal Information" },
      { sec_id: 2, sec_name: "Addresses" },
      { sec_id: 3, sec_name: "Job Detail" },
      { sec_id: 4, sec_name: "Custom Fields" },
    ],
  },
  {
    screen_id: 3,
    screen_name: "Client Branches",
    sections: [
      { sec_id: 1, sec_name: "Personal Information" },
      { sec_id: 2, sec_name: "Addresses" },
      { sec_id: 3, sec_name: "Job Detail" },
      { sec_id: 4, sec_name: "Custom Fields" },
    ],
  },
  {
    screen_id: 4,
    screen_name: "State Master",
    sections: [
      { sec_id: 1, sec_name: "Personal Information" },
      { sec_id: 2, sec_name: "Addresses" },
      { sec_id: 3, sec_name: "Job Detail" },
      { sec_id: 4, sec_name: "Custom Fields" },
    ],
  },
];

const SearchComponent = () => {
  const [searchText, setSearchText] = useState("");
  const [selectedScreens, setSelectedScreens] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [visibleSections, setVisibleSections] = useState({});
  const [selectedSections, setSelectedSections] = useState({});
  // Introducing permissions state to track screen-level permissions
  const [permissions, setPermissions] = useState({});

  const handleSearch = () => {
    const filteredResults = data.filter((item) =>
      item.screen_name.toLowerCase().includes(searchText.toLowerCase())
    );
    setSearchResults(filteredResults);
  };

  const handleSelectItem = (item) => {
    if (
      !selectedScreens.some((screen) => screen.screen_id === item.screen_id)
    ) {
      setSelectedScreens([...selectedScreens, item]);
    }
  };

  const handleDeleteItem = (screenId) => {
    setSelectedScreens(
      selectedScreens.filter((screen) => screen.screen_id !== screenId)
    );
    const updatedVisibleSections = { ...visibleSections };
    delete updatedVisibleSections[screenId];
    setVisibleSections(updatedVisibleSections);
    const updatedSelectedSections = { ...selectedSections };
    delete updatedSelectedSections[screenId];
    setSelectedSections(updatedSelectedSections);
    // Also remove permissions for the deleted screen
    const updatedPermissions = { ...permissions };
    delete updatedPermissions[screenId];
    setPermissions(updatedPermissions);
  };

  const toggleSectionVisibility = (screenId) => {
    setVisibleSections((prevState) => ({
      ...prevState,
      [screenId]: !prevState[screenId],
    }));
  };

  const handleSectionSelect = (screenId, sectionId) => {
    const updatedSelectedSections = { ...selectedSections };
    if (!updatedSelectedSections[screenId]) {
      updatedSelectedSections[screenId] = new Set();
    }
    if (updatedSelectedSections[screenId].has(sectionId)) {
      updatedSelectedSections[screenId].delete(sectionId);
    } else {
      updatedSelectedSections[screenId].add(sectionId);
    }
    setSelectedSections(updatedSelectedSections);
  };

  const handlePermissionChange = (screenId, permissionType, isChecked) => {
    const updatedPermissions = { ...permissions };
    if (!updatedPermissions[screenId]) {
      updatedPermissions[screenId] = {};
    }
    updatedPermissions[screenId][permissionType] = isChecked;
    setPermissions(updatedPermissions);
  };

  return (
    <div>
      <div className="search-container">
        <input
          type="text"
          placeholder="Search..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <button onClick={handleSearch}>Search</button>
      </div>
      <ul>
        {searchResults.map((item) => (
          <li
            key={item.screen_id}
            onClick={() => handleSelectItem(item)}
            style={{ cursor: "pointer" }}
          >
            {item.screen_name}
          </li>
        ))}
      </ul>
      <div>
        {selectedScreens.map((screen) => (
          <div key={screen.screen_id}>
            <h3>
              {screen.screen_name}
              <button
                onClick={() => handleDeleteItem(screen.screen_id)}
                style={{ marginLeft: "10px" }}
              >
                Delete
              </button>
            </h3>

            <div style={{ marginLeft: "20px" }}>
              <button
                onClick={() => toggleSectionVisibility(screen.screen_id)}
                style={{ marginLeft: "5px" }}
              >
                {visibleSections[screen.screen_id] ? "-" : "+"} Edit
              </button>
              <label>
                <input
                  type="checkbox"
                  checked={permissions[screen.screen_id]?.create || false}
                  onChange={(e) =>
                    handlePermissionChange(
                      screen.screen_id,
                      "create",
                      e.target.checked
                    )
                  }
                />{" "}
                Create
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={permissions[screen.screen_id]?.update || false}
                  onChange={(e) =>
                    handlePermissionChange(
                      screen.screen_id,
                      "update",
                      e.target.checked
                    )
                  }
                />{" "}
                Update
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={permissions[screen.screen_id]?.delete || false}
                  onChange={(e) =>
                    handlePermissionChange(
                      screen.screen_id,
                      "delete",
                      e.target.checked
                    )
                  }
                />{" "}
                Delete
              </label>
            </div>
            {visibleSections[screen.screen_id] && (
              <ul>
                {screen.sections.map((section) => (
                  <li key={section.sec_id}>
                    <label>
                      <input
                        type="checkbox"
                        checked={
                          selectedSections[screen.screen_id]?.has(
                            section.sec_id
                          ) || false
                        }
                        onChange={() =>
                          handleSectionSelect(screen.screen_id, section.sec_id)
                        }
                      />
                      {section.sec_name}
                    </label>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchComponent;
